export default {
    'diagram3b2-2': {
        'diagram-task': 'Q: How is it encouraged?',
        'diagram-hint': 'Steps',
        'diagram-hint2': '(Ways it is encouraged)',
        'fixed-answer': 'In the start-up world, endemic optimism is encouraged',
        'element_2_1': 'Early positive feedback',
        'element_2_2': 'Rise of accelerator boot camps',
        'element_2_3': 'Acceptance of failure as normal',
      'diagram-description-1': 'Early positive feedback',
      'diagram-description-2': 'Rise of accelerator bootcamps',
      'diagram-description-3': 'Finding and mentoring network services',
      'diagram-description-4': 'Acceptance of failure as normal',
      'diagram-description-5': '“Fail fast, fail often” mantra',
      'diagram-description-6': 'FailCons that tell about hard times'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b2/diagram2/i18n/en.js